import React, { useState, useEffect } from 'react';
import { Modal, Space, Typography } from 'antd';
import axios from 'axios';
import dotenv from 'dotenv';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import './index.css';

interface IProps {
    modalVisible: boolean;
    closeModal: () => void;
    rowData: {
        comapanyId: number;
        franchiseId: number;
        lat: number;
        lng: number;
        name: string;
        phoneNumber: string;
        address: string;
    };
}

const LocationDetail: React.FC<IProps> = ({
    modalVisible,
    rowData,
    closeModal,
}): JSX.Element => {
    const { Text } = Typography;

    const [address, setAddress] = useState<any>('');
    const [position, setPosition] = useState({
        lat: 0,
        lng: 0,
    });

    useEffect(() => {
        setPosition({ lat: rowData.lat, lng: rowData.lng });
    }, [rowData]);

    const handleClose = () => {
        closeModal();
        setPosition({ lat: 0, lng: 0 });
        setAddress('');
    };

    return (
        <Modal
            visible={modalVisible}
            title={`Información de ${rowData.name}`}
            onCancel={() => handleClose()}
            width="65%"
            footer={null}
            destroyOnClose={true}
        >
            <div className="container__map__modal">
                <div style={{ width: '70%', height: '600px' }}>
                    <LoadScript
                        // @ts-ignore
                        googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                    >
                        <GoogleMap
                            mapContainerStyle={{
                                width: '100%',
                                height: '100%',
                            }}
                            center={{ lat: rowData.lat, lng: rowData.lng }}
                            zoom={18}
                        >
                            <Marker position={position} />
                        </GoogleMap>
                    </LoadScript>
                </div>
                <div className="container__details__table">
                    <Space direction="vertical">
                        <Text strong>Nombre</Text>
                        <Text type="secondary">{rowData.name}</Text>

                        <Text strong>Telefono</Text>
                        <Text type="secondary">{rowData.phoneNumber}</Text>

                        <Text strong>Ubicación</Text>
                        <Text type="secondary">{rowData.address}</Text>
                    </Space>
                </div>
            </div>
        </Modal>
    );
};

export default LocationDetail;
